import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store/store";
import { Role } from "./_helper.js";

function lazyLoad(view: string) {
  return () => import(`@/views/${view}.vue`);
}
function lazyLoadComponent(view: string) {
  return () => import(`@/components/${view}.vue`);
}

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/schedules",
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/schedules",
    name: "Schedules",
    component: lazyLoadComponent("calendar/StaffCalendar"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/classroom",
    name: "Classroom",
    component: lazyLoad("Classroom"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/course/:id",
    name: "CourseDetail",
    component: lazyLoad("CourseDetail"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/student/:id",
    name: "Student",
    component: lazyLoad("Student"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/edit-profile",
    name: "EditProfile",
    component: lazyLoad("EditProfile"),
    meta: {
      authorize: [Role.Teacher],
    },
  },
  {
    path: "/admin-messages",
    name: "AdminMessages",
    component: lazyLoad("AdminMessages"),
    meta: {
      authorize: [Role.Teacher],
    },
  },
  {
    path: "/timescan/:req?",
    name: "TimeScan",
    component: lazyLoad("TimeScan"),
    meta: { requiresAuth: false },
  },
  {
    path: "/timesheet",
    name: "Timesheet",
    component: lazyLoadComponent("timetrack/MyTimesheet"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: lazyLoadComponent("error/Unauthorized"),
    meta: { authorize: [] },
  },
  {
    path: "/login",
    name: "Login",
    component: lazyLoadComponent("auth/Login"),
    meta: { authorize: [] },
  },
  {
    path: "/secure/reset/password",
    name: "ResetPassword",
    component: lazyLoad("secure/ResetPassword"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/availability/:id?",
    name: "Availability",
    component: lazyLoad("Availability"),
    meta: { authorize: [] },
  },
  {
    path: "/attendance",
    name: "Attendance",
    component: lazyLoad("Attendance"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/student-attendance-offline-report:data",
    name: "AttendanceOfflineReport",
    component: lazyLoadComponent("attendance/AttendanceOfflineReport"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/print-checklist/:data",
    name: "PrintChecklist",
    component: lazyLoad("PrintChecklist"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/print-attendance/:data",
    name: "PrintAttendance",
    component: lazyLoad("PrintAttendance"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/print-monthly-attendance",
    name: "MonthlyAttendancePrint",
    component: lazyLoad("MonthlyAttendancePrint"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
  {
    path: "/print-monthly-checklist/:data",
    name: "MonthlyChecklistPrint",
    component: lazyLoad("MonthlyChecklistPrint"),
    meta: { requiresAuth: true, authorize: [Role.Teacher] },
  },
];

const router = new VueRouter({
  routes,
});

function isAuthorized(authorize: string[]) {
  if (!authorize || authorize.length < 1) {
    return true;
  }

  // let hasModule = false;
  // const userModules = store.getters.userModules;
  // if(userModules && userModules.length > 0){
  //   hasModule = userModules.some(m => m && m.path === 'staff');
  // }

  const userRoles = store.getters.userRoles;
  // if(hasModule && userRoles && userRoles.length > 0){
  if (userRoles && userRoles.length > 0) {
    return userRoles.some((r: any) => authorize.includes(r));
  } else {
    store.dispatch("addErrorMessage", "Unauthorized Access");
    return false;
  }
}

router.beforeEach((to, from, next) => {
  if (
    to.matched.some(
      (record) =>
        record.path.startsWith("/secure/") || record.meta.requiresAuth,
    )
  ) {
    const { authorize } = to.meta as any;
    if (store.getters.isLoggedIn) {
      //is logged in and has authorized permission
      if (isAuthorized(authorize)) {
        next();
        return;
      } else {
        //Is logged in, but not authorized
        // store.dispatch("processLogout");
        next("/unauthorized");
      }
    }
    //not logged in
    else {
      //Check if jwt token exists and attempt to automatically log in
      store
        .dispatch("remoteJwtTokenCheck")
        .then(() => {
          //check if user is authorized
          if (isAuthorized(authorize)) {
            next();
          } else {
            //not authorized
            store.dispatch("processLogout");
            next({ name: "Login", query: { redirect: to.path } });
          }
        })
        .catch(() => {
          // console.log('fail jwt token check')
          store.dispatch("processLogout");
          next({ name: "Login", query: { redirect: to.path } });
        });
    }
  } else {
    //accessing non-secured page
    next();
  }
});

export default router;
